import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'number-4', 'IconNumber4', [["path",{"d":"M15 20v-15l-8 11h10","key":"svg-0"}]]);